<template><section>
<h1>Loading 加载中</h1>
<h3>基本用法</h3>
<demo-block>
                    <div class="source" slot="source"><template>
  <div>
    <nt-button @click="showPageloading">显示loading</nt-button>
  </div>
</template>


</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span>  <span class="hljs-attr">@click</span>=<span class="hljs-string">"showPageloading"</span>&gt;</span>显示loading<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
     showPageloading() {
      <span class="hljs-keyword">this</span>.$ntLoadingShow();
      setTimeout(<span class="hljs-function"><span class="hljs-params">()</span>=&gt;</span>{
        <span class="hljs-keyword">this</span>.$ntLoadingHide();
      },<span class="hljs-number">2000</span>)
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>Loading样式</h3>
<demo-block>
                    <div class="source" slot="source"><template>
  <div>
    <nt-button @click="showSpinloading">显示loading</nt-button>
    <nt-button @click="showEarthloading">显示loading</nt-button>
    <nt-button @click="showDiskloading">显示loading</nt-button>
  </div>
</template>


</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span>  <span class="hljs-attr">@click</span>=<span class="hljs-string">"showSpinloading"</span>&gt;</span>显示loading<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span>  <span class="hljs-attr">@click</span>=<span class="hljs-string">"showEarthloading"</span>&gt;</span>显示loading<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span>  <span class="hljs-attr">@click</span>=<span class="hljs-string">"showDiskloading"</span>&gt;</span>显示loading<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
     showPageloading() {
      <span class="hljs-keyword">this</span>.$ntLoadingShow();
      setTimeout(<span class="hljs-function"><span class="hljs-params">()</span>=&gt;</span>{
        <span class="hljs-keyword">this</span>.$ntLoadingHide();
      },<span class="hljs-number">2000</span>)
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">type</td>
<td style="text-align:left">显示loading的类型</td>
<td style="text-align:left">String</td>
<td style="text-align:left">earth, spin, disk</td>
<td style="text-align:left">spin</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">this.$ntLoadingShow();</td>
<td style="text-align:left">显示loading</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">this.$ntLoadingHide();</td>
<td style="text-align:left">隐藏loading</td>
<td style="text-align:left">-</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  methods: {
    showPageloading() {
      this.$ntLoadingShow();
      setTimeout(()=>{
        this.$ntLoadingHide();
      },2000)
    },
    showSpinloading() {
      this.$ntLoadingShow();
      setTimeout(()=>{
        this.$ntLoadingHide();
      },2000)
    },
    showEarthloading() {
      this.$ntLoadingShow({
          type:'earth'
      });
      setTimeout(()=>{
        this.$ntLoadingHide();
      },2000)
    },
    showDiskloading() {
      this.$ntLoadingShow({
          type:'disk'
      });
      setTimeout(()=>{
        this.$ntLoadingHide();
      },2000)
    },
  }
};
</script>